import { UnsubscribedContactsStatusCounts } from '@/store/contacts/types';
import { TotalContactHeaders } from '@/services/dictionaries/Headers';

export const extractUnsubscribedContactsStatusCounts = (
    headers: Record<string, React.ReactText>
): UnsubscribedContactsStatusCounts => ({
        total: Number(headers[TotalContactHeaders.TotalCount]) || 0,
        unsubscribed: Number(headers[TotalContactHeaders.UnsubscribedCount]) || 0,
        abused: Number(headers[TotalContactHeaders.AbuseCount]) || 0,
    });
